import React, { Component } from "react";

import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Button,
  Label,
  Input,
  Container,
  CustomInput,
} from "reactstrap";
import Select from "react-select";
import { connect } from "react-redux";
// import { AvForm, AvField, AvInput } from "availity-reactstrap-validation";
import "./UserProfile.scss";
import avatar2 from "../../assets/images/users/Default_User.png";
import { getUser } from "../../store/UserProfile/actions";
import { getMiniLocations, getMiniDepartment } from "../../store/Mini/actions";

class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = { file: "", imagePreviewUrl: "" };
  }
  handleImageChange(e) {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      this.setState({
        file: file,
        imagePreviewUrl: reader.result,
      });
    };

    reader.readAsDataURL(file);
  }
  componentDidMount() {
    this.props.getUser(1);
    this.props.getMiniDepartments();
    this.props.getMiniLocations();
  }

  render() {
    var data = this.props.userData;
    let { imagePreviewUrl } = this.state;
    let $imagePreview = null;
    if (imagePreviewUrl) {
      $imagePreview = (
        <img
          className="img-thumbnail rounded-circle"
          alt="User"
          src={imagePreviewUrl}
        />
      );
    } else {
      $imagePreview = (
        <img
          className="img-thumbnail rounded-circle"
          alt="User"
          src={avatar2}
        />
      );
    }
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Card>
              <CardHeader className="bg-transparent border-bottom">
                <h3 className="card-title-18 pt-2">Personal Profile</h3>
              </CardHeader>
              <CardBody>
                <Row className="justify-content-center">
                  <Col xs={9}>
                    <Card>
                      <CardBody>
                        <h4 className="card-title-18">General</h4>
                        <form>
                          <Row className="justify-content-center">
                            <Col xs={9}>
                              <FormGroup row>
                                <Col md={3}></Col>
                                <Col md={9}>
                                  <Row className="justify-content-center">
                                    <Col md={4}>
                                      <div className="p-image">
                                        <div className="mt-1 align-items-center ">
                                          <label htmlFor="customFile">
                                            <div className="img-icon">
                                              <i className="ri-camera-fill "></i>
                                            </div>
                                            {$imagePreview}
                                            {/* <img
                                            className="img-thumbnail rounded-circle"
                                            alt="User"
                                            src={avatar2}
                                          /> */}
                                          </label>
                                          {/* <label >
                                            <p>img</p>
                                          </label> */}

                                          <CustomInput
                                            type="file"
                                            className="file-upload"
                                            id="customFile"
                                            accept="image/*"
                                            multiple={false}
                                            onChange={(e) =>
                                              this.handleImageChange(e)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </FormGroup>
                              <FormGroup row>
                                <Col md={3}>
                                  <Label
                                    htmlFor="userName-text-input"
                                    className="col-form-label float-right"
                                  >
                                    User Name
                                  </Label>
                                </Col>
                                <Col md={9}>
                                  <Input
                                    className="form-control"
                                    type="text"
                                    value={data.username}
                                    readOnly
                                    id="userName-text-input"
                                    disabled={true}
                                  />
                                </Col>
                              </FormGroup>
                              <FormGroup row>
                                <Col md={3}>
                                  <Label
                                    htmlFor="email_input"
                                    className="col-form-label float-right"
                                  >
                                    Email
                                  </Label>
                                </Col>
                                <Col md={9}>
                                  <Input
                                    className="form-control"
                                    type="email"
                                    value={data.email}
                                    name="email"
                                    readOnly
                                    id="email_input"
                                  />
                                </Col>
                              </FormGroup>
                              <FormGroup row>
                                <Col md={3}>
                                  <Label
                                    htmlFor="first_name_input"
                                    className="col-form-label float-right"
                                  >
                                    First Name
                                  </Label>
                                </Col>
                                <Col md={9}>
                                  <Input
                                    className="form-control"
                                    type="text"
                                    value={data.first_name}
                                    name="first_name"
                                    id="first_name_input"
                                  />
                                </Col>
                              </FormGroup>
                              <FormGroup row>
                                <Col md={3}>
                                  <Label
                                    htmlFor="last_name_input"
                                    className="col-form-label float-right"
                                  >
                                    last Name
                                  </Label>
                                </Col>
                                <Col md={9}>
                                  <Input
                                    className="form-control"
                                    type="text"
                                    value={data.last_name}
                                    name="last_name"
                                    id="last_name_input"
                                  />
                                </Col>
                              </FormGroup>

                              <FormGroup row>
                                <Col md={3}>
                                  <Label
                                    htmlFor="phone_input"
                                    className=" col-form-label float-right"
                                  >
                                    Mobile No
                                  </Label>
                                </Col>
                                <Col md={9}>
                                  <Input
                                    className="form-control"
                                    type="tel"
                                    value={data.phone}
                                    name="phone"
                                    id="phone_input"
                                  />
                                </Col>
                              </FormGroup>
                              <FormGroup row>
                                <Col md={3}>
                                  <Label
                                    htmlFor="dob_input"
                                    className=" col-form-label float-right"
                                  >
                                    Date of Birth
                                  </Label>
                                </Col>
                                <Col md={9}>
                                  <Input
                                    className="form-control"
                                    type="date"
                                    value={data.dob}
                                    name="dob"
                                    id="dob_input"
                                  />
                                </Col>
                              </FormGroup>
                              <FormGroup row>
                                <Col md={3}>
                                  <Label
                                    htmlFor="Vendorlist"
                                    className="col-form-label float-right"
                                  >
                                    Departments
                                  </Label>
                                </Col>
                                <Col md={9}>
                                  <Select
                                    id="Vendorlist"
                                    name="Vendorlist"
                                    isMulti
                                    classNamePrefix="select-vendorlist"
                                    options={this.props.deparmentslist.map(
                                      (item, index) => ({
                                        label: item.name,
                                        value: item.id,
                                      })
                                    )}
                                    value={data && data.departments}
                                    // onChange={(vendorvalues) =>
                                    //   this.props.ProductVendorsValue(
                                    //     vendorvalues
                                    //   )
                                    // }
                                  />
                                </Col>
                              </FormGroup>
                              <FormGroup row>
                                <Col md={3}>
                                  <Label
                                    htmlFor="user-location"
                                    className=" col-form-label float-right "
                                    id="user-location-input"
                                  >
                                    Select Location
                                  </Label>
                                </Col>
                                <Col md={9}>
                                  <Select
                                    id="user-location"
                                    name="location"
                                    classNamePrefix="select2-selection"
                                    options={this.props.locationslist.map(
                                      (item, index) => ({
                                        label: item.name,
                                        value: item.id,
                                      })
                                    )}
                                    value={{
                                      label: data.locationLabel,
                                      value: data.location_id,
                                    }}
                                    // onChange={(e) => {
                                    //   this.props.ProductSelecteChangeValue({
                                    //     key: "baseunitLabel",
                                    //     label: e.label,
                                    //     key2: "baseunit_id",
                                    //     value: e.value,
                                    //   });
                                    // }}
                                  />
                                </Col>
                              </FormGroup>
                              <FormGroup row>
                                <Col md={3}>
                                  <Label
                                    htmlFor="user-gender-input"
                                    className=" col-form-label float-right"
                                  >
                                    Select Gender
                                  </Label>
                                </Col>
                                <Col md={9}>
                                  <select
                                    className="form-control"
                                    id="user-gender-input"
                                  >
                                    <option>Select</option>
                                    <option>Male</option>
                                    <option>FeMale</option>
                                  </select>
                                </Col>
                              </FormGroup>
                              <FormGroup row>
                                <Col md={3}>
                                  <Label
                                    htmlFor="user-Profile-input"
                                    className=" col-form-label float-right "
                                    id="user-Profile-input"
                                  >
                                    Select Profile
                                  </Label>
                                </Col>
                                <Col md={9}>
                                  <select className="form-control">
                                    <option>Select</option>
                                    <option>Web Developer</option>
                                    <option>Admin</option>
                                  </select>
                                </Col>
                              </FormGroup>

                              <div className="float-right">
                                <Button
                                  type="submit"
                                  color="primary"
                                  className="mr-2"
                                >
                                  Save
                                </Button>
                                <Button type="submit" color="light">
                                  Cancel
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </form>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
const mapStatetoProps = (state) => {
  const { locationslist, deparmentslist } = state.Mini;
  const { userData } = state.userProfile;
  // const { deparmentslist } = state.Department;
  // const { model, selectedItems, reqrowdata } = state.Materialrequest;
  return {
    userData,

    locationslist,
    deparmentslist,
  };
};

export default connect(mapStatetoProps, {
  getUser,
  getMiniLocations,
  getMiniDepartment,
})(UserProfile);
// export default UserProfile;
